import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Why_Choose_Our_Mobile_App_Design_Services_Card_BG.svg")